import React, { PropsWithChildren, useEffect, useRef } from 'react';
import { PanResponder } from 'react-native';
import { SafeAreaProvider, SafeAreaView } from 'react-native-safe-area-context';
import constants from '@/config/constants';
import store from '@/stores/store';
import { ScreenshotPrevention } from '@/components/ScreenshotPrevention';
import { useIdleLogout } from '@/hooks/useIdleLogout';

export function Layout({ children }: PropsWithChildren) {
  const { resetTimer } = useIdleLogout();

  const panResponder = useRef(
    PanResponder.create({
      onStartShouldSetPanResponderCapture: () => {
        const { stayLoggedIn, isAuthenticated } = store.getState();

        // Track users who signed in without checkbox to stay logged in to log them out
        if (isAuthenticated && !stayLoggedIn) {
          resetTimer();
        }
        return false;
      },
    }),
  ).current;

  return (
    <SafeAreaProvider>
      <SafeAreaView style={{ flex: 1 }} {...panResponder.panHandlers}>
        {constants.screenshotPreventionEnabled ? (
          <ScreenshotPrevention>{children}</ScreenshotPrevention>
        ) : (
          children
        )}
      </SafeAreaView>
    </SafeAreaProvider>
  );
}
